import { render } from "./edit-blog.vue?vue&type=template&id=3360c846"
import script from "./edit-blog.vue?vue&type=script&lang=js"
export * from "./edit-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__